import { render } from "./suishoupai.vue?vue&type=template&id=e5e11bf2&scoped=true&ts=true"
import script from "./suishoupai.vue?vue&type=script&lang=ts"
export * from "./suishoupai.vue?vue&type=script&lang=ts"

import "./suishoupai.vue?vue&type=style&index=0&id=e5e11bf2&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e11bf2"]])

export default __exports__